import { getAsyncTypes } from '../helpers/actionType';
import * as XrsBTrxService from '../services/XrsBTrxService'
import { dispatchWithNotification } from '../redux/Notification'
import log from '../helpers/logger';
import { toMoney } from '../helpers/formatter';
import { objectListToDict, mergeArray } from '../helpers/utils';
import { RememberCurrent, GetCurrent } from './Persist'
import { version } from 'react';

// action types
const SCREEN_PREFIX = 'XrsBTrx';
const MST_KEY_COLUMNNAME = "BTrxId64";
const DTL_KEY_COLUMNNAME = "BTrxDetId65"
const MST_SESSION_KEYNAME = SCREEN_PREFIX + '_Mst';
const DTL_SESSION_KEYNAME = SCREEN_PREFIX + '_Dtl';
export const LOAD_PAGE = getAsyncTypes(SCREEN_PREFIX + '_LOAD_PAGE');
export const GET_SEARCH_LIST = getAsyncTypes(SCREEN_PREFIX + '_GET_SEARCH_LIST');
export const GET_MST = getAsyncTypes(SCREEN_PREFIX + '_GET_MST');
export const ADD_MST = getAsyncTypes(SCREEN_PREFIX + '_ADD_MST');
export const DEL_MST = getAsyncTypes(SCREEN_PREFIX + '_DEL_MST');
export const GET_DTL_LIST = getAsyncTypes(SCREEN_PREFIX + '_GET_DTL_LIST');
export const ADD_DTL = getAsyncTypes(SCREEN_PREFIX + '_ADD_DTL');
export const DEL_DTL = getAsyncTypes(SCREEN_PREFIX + '_ADD_DTL');
export const DEL_ALLDTL = getAsyncTypes(SCREEN_PREFIX + '_ADD_ALLDTL');
export const SAVE_MST = getAsyncTypes(SCREEN_PREFIX + '_SAVE_MST');
export const SAVE_DTL = getAsyncTypes(SCREEN_PREFIX + '_SAVE_DTL');
export const EDIT_DTL = getAsyncTypes(SCREEN_PREFIX + '_EDIT_DTL');
export const GET_DDL_CHARTID = getAsyncTypes(SCREEN_PREFIX + '_GET_DDL_CHARTID');
export const GET_DDL_CURRENCYID = getAsyncTypes(SCREEN_PREFIX + '_GET_DDL_CURRENCYID');
export const GET_DDL_MEMBERID = getAsyncTypes(SCREEN_PREFIX + '_GET_DDL_MEMBERID');
export const GET_DDL_CUSTOMERJOBID = getAsyncTypes(SCREEN_PREFIX + '_GET_DDL_CUSTOMERJOBID');
export const GET_DDL_PROJECTID = getAsyncTypes(SCREEN_PREFIX + '_GET_DDL_PROJECTID');
export const SELECT_MST = getAsyncTypes(SCREEN_PREFIX + '_SELECT_MST');
export const SAVE_CRI = getAsyncTypes(SCREEN_PREFIX + '_SAVE_CRI');
export const VIEW_MORE_DTL = getAsyncTypes(SCREEN_PREFIX + '_VIEW_MORE_DTL'); '';
export const CHANGE_MSTLIST_FILTER_VISIBILITY = SCREEN_PREFIX + '_CHANGE_MSTLIST_FILTER_VISIBILITY';
export const CHANGE_DTLLIST_FILTER_VISIBILITY = SCREEN_PREFIX + '_CHANGE_DTLLIST_FILTER_VISIBILITY';
export const CHANGE_DTLLIST_FILTER = SCREEN_PREFIX + '_CHANGE_DTLLIST_FILTER';



//reducer
const initialState = {

  AuthRow: {
    AllowAdd: true,
    AllowDel: true,
    AllowUpd: true,
    ViewOnly: false
  },
  AuthCol: {
    BTrxId64: { visible: true, readonly: false },
    CompanyId64: { visible: true, readonly: false },
    ProjectId64: { visible: true, readonly: false },
    MemberId64: { visible: true, readonly: false },
    CustomerJobId64: { visible: true, readonly: false },
    TrxDate64: { visible: true, readonly: false },
    CurrencyId64: { visible: true, readonly: false },
    TrxTotal64: { visible: true, readonly: false },
    TrxDocId64: { visible: true, readonly: false },
    TrxNote64: { visible: true, readonly: false },
    Posted64: { visible: true, readonly: false },
    PostToAp: { visible: true, readonly: false },
    PrintRpt: { visible: true, readonly: false },
    BTrxDetId65: { visible: true, readonly: false },
    TrxDetImg65: { visible: true, readonly: false },
    TrxDetDate65: { visible: true, readonly: false },
    BGlChartId65: { visible: true, readonly: false },
    TrxDetDesc65: { visible: true, readonly: false },
    LocalCurrency65: { visible: true, readonly: false },
    HasReceipt65: { visible: true, readonly: false },
    TrxDetAmt65: { visible: true, readonly: false },
    TrxDetGst65: { visible: true, readonly: false },
  },
  ColumnLabel: {
    BTrxId64: { ColumnHeader: "Expense Id" },
    CompanyId64: { ColumnHeader: "Company" },
    ProjectId64: { ColumnHeader: "Project" },
    MemberId64: { ColumnHeader: "Member" },
    CustomerJobId64: { ColumnHeader: "Job" },
    TrxDate64: { ColumnHeader: "Transaction Date" },
    CurrencyId64: { ColumnHeader: "Currency" },
    TrxTotal64: { ColumnHeader: "Transaction Total" },
    TrxDocId64: { ColumnHeader: "Supporting Doc" },
    TrxNote64: { ColumnHeader: "Memo" },
    Posted64: { ColumnHeader: "Posted" },
    PostToAp: { ColumnHeader: "Posted to AP" },
    PrintRpt: { ColumnHeader: "Print" },
    BTrxDetId65: { ColumnHeader: "Detail ID" },
    TrxDetImg65: { ColumnHeader: "Receipt image" },
    TrxDetDate65: { ColumnHeader: "Date" },
    BGlChartId65: { ColumnHeader: "GL Chart" },
    TrxDetDesc65: { ColumnHeader: "Detail Desc" },
    LocalCurrency65: { ColumnHeader: "Local Currency" },
    HasReceipt65: { ColumnHeader: "Has Receipt" },
    TrxDetAmt65: { ColumnHeader: "Amount" },
    TrxDetGst65: { ColumnHeader: "Tax" },
  },
  Label: {
    AddExpenseTitle: "Add Expense",
    AddExpenseSubtitle: "Please enter your expense details",
    RequestPaymentTitle: "Request Payment",
    RequestPaymentSubtitle: "Submit request to A/P for payment approval",
    DashboardTitle: "Dashboard",
    DashboardSubtitle: "Please select a currency to start with",

    UsernamePlaceholder: "Enter your username",
    PasswordPlaceholder: "Enter you password",
    UsernameFIeld: "Username",
    PasswordField: "Password",
    LoginTitle: "Login to Your Account",
    LoginSubtitle: "Please enter your login details",
    ItemTitle: "Item",
    ItemSubtitle: "Enter or update expense item details",
    ReportTitle: "Report",
    ReportSubtitle: "Manage your report information",
    DashboardTitle: "Dashboard",
    DashboardSubtitle: "Create or choose report",
    ItemListTitle: "Item List",
    ItemListSubtitle: "List of expense items inside report",
    ExpsensesToSubmit: "Expenses in this record",
    TotalSubtitle: "Total",
    Memo: "Memo",
    ExpenseItemsInReport: "Items found:",
    RequestPaymentTitle: "Request Payment",
    RequestPaymentSubtitle: "Submit request to A/P for payment approval",
    CancelButton: "Cancel",
    SaveButton: "Save",
    RequestPaymentButton: "Request Payment",
    SaveOnlyButton: "Save Only",
    SaveAndPayMeButton: "Save & Pay Me",
    AddExpenseButton: "Add Expense",

    SignInButton: "Sign In",
    AddExpenseItemButton: "Add Expense Item",
    ViewExpenseItemsButton: "View Expense Items",
    SaveExpenseItemButton: "Save Expense Item",
    PostToAPButton: "Post to A/P",
    ViewMoreButton: "View {0} more",
    EmailReportButton: "Email report",
    ExportReportButton: "Export report",
    CopyReportButton: "Copy report",
    PrintReportButton: "Print Report",
    HelpButton: "Help",
    DeleteReportButton: "Delete report",
    CopyItemButton: "Copy Item",
    DeleteItemButton: "Delete Item",
    AddExpenseSuccess: "Expense has been successfully added",
    PaymentSuccess: "Payment has been successfully requested",
    LivingPage: "You have not saved your changes. Are you sure you want to leave?",
    AccountValidation: "Please select the account",
    DescriptionValidation: "Please enter the description",
    AmountValidation: "Please enter the amount",
    GstValidation: "Please enter the GST",
    ProjectValidation: "Please select the project",
    JobValidation: "Please select the customer job",
    MemoValidation: "Please enter the memo",
    UsernameValidation: "Please enter your username",
    Password: "Please enter your passwrod",
    SiteTitle: "Expense Report",
    Dashboard: "Dashboard",
    Item: "Item",
    ItemList: "Item List",
    Report: "Report",
    Login: "Login",
    Logout: "Logout",
    UnSavedPage: "You have not saved your changes. Are you sure you want to leave?",
    SearchPlaceholder: "On",
    FilterLabel: "Filter",
    QuickFilterLabel: "Quick Filter",
    NoResultsLabel: "No results found.",
  },

  Buttons: {
    key: Date.now(),
    MstList: {
      DropdownMenuButtons: {
        SaveCloseButton: { label: 'Email report', iconClassName: 'fa fa-envelope mr-10', className: 'dropdown-button-blue', buttonType: 'SaveClose', visible: false, order: 1, expose: false },
        ExpTxtButton: { label: 'Export report', iconClassName: 'fa fa-file-text mr-10', className: 'dropdown-button-blue', buttonType: 'ExpTxt', visible: false, order: 2, expose: false },
        CopyButton: { label: 'Copy report', iconClassName: 'fa fa-clipboard mr-10', className: 'dropdown-button-blue', buttonType: 'Copy', visible: false, order: 3, expose: false },
        PrintButton: { label: 'Print report', iconClassName: 'fa fa-print mr-10', className: 'dropdown-button-blue', buttonType: 'Print', visible: false, order: 4, expose: false },
        DeleteButton: { label: 'Delete report', iconClassName: 'fa fa-trash mr-10', className: 'dropdown-button-red', buttonType: 'Delete', visible: false, order: 5, expose: false },
        InsRowButton: { label: 'Add expense item', iconClassName: 'fa fa-plus mr-10', className: 'dropdown-button-blue', buttonType: 'InsRow', visible: false, order: 6, expose: false },
        ViewDtlListButton: { label: 'View expense items', iconClassName: 'fa fa-eye mr-10', className: 'dropdown-button-blue', buttonType: 'ViewDtlList', visible: false, order: 7, expose: false },
      },
      RowButtons: {
        ViewDtlListButton: { label: 'View expense items', iconClassName: 'fa fa-list-ul', exposedClassName: 'edit-icon', className: 'dropdown-button-blue', buttonType: 'ViewDtlList', visible: false, order: 1, expose: false },
        InsRowButton: { label: 'Add expense item', iconClassName: 'fa fa-plus', exposedClassName: 'edit-icon', className: 'dropdown-button-blue', buttonType: 'InsRow', visible: false, order: 2, expose: false },
        EditMstButton: { label: 'View report', iconClassName: 'fa fa-eye', exposedClassName: 'edit-icon', className: 'dropdown-button-blue', buttonType: 'EditMst', visible: false, order: 3, expose: false },
        CopyButton: { label: 'Copy report', iconClassName: 'fa fa-clipboard', exposedClassName: 'edit-icon', className: 'dropdown-button-blue', buttonType: 'Copy', visible: false, order: 4, expose: false },
        DeleteButton: { label: 'Delete report', iconClassName: 'fa fa-trash', exposedClassName: 'edit-icon', className: 'dropdown-button-red', buttonType: 'Delete', visible: false, order: 5, expose: false },
      },
      BottomButtons: {
        InsRowButton: { label: 'Add Expense Item', buttonType: 'InsRow', visible: false, order: 1, expose: true },
        ViewDtlListButton: { label: 'View Expense Items', buttonType: 'ViewDtlList', visible: false, order: 2, expose: true },
        CopyButton: { label: 'Copy Report', buttonType: 'Copy', visible: false, order: 3, expose: true },
        DeleteButton: { label: 'Delete Report', buttonType: 'Delete', visible: false, order: 4, expose: true },
      }
    },
    Mst: {
      DropdownMenuButtons: {
        SaveCloseButton: { label: 'Email report', iconClassName: 'fa fa-envelope mr-10', className: 'dropdown-button-blue', buttonType: 'SaveClose', visible: true, order: 1, expose: false },
        ExpTxtButton: { label: 'Export report', iconClassName: 'fa fa-file-text mr-10', className: 'dropdown-button-blue', buttonType: 'ExpTxt', visible: false, order: 2, expose: false },
        CopyButton: { label: 'Copy report', iconClassName: 'fa fa-clipboard mr-10', className: 'dropdown-button-blue', buttonType: 'Copy', visible: true, order: 3, expose: false },
        PrintButton: { label: 'Print report', iconClassName: 'fa fa-print mr-10', className: 'dropdown-button-blue', buttonType: 'Print', visible: false, order: 4, expose: false },
        DeleteButton: { label: 'Delete report', iconClassName: 'fa fa-trash mr-10', className: 'dropdown-button-red', buttonType: 'Delete', visible: true, order: 5, expose: false },
        InsRowButton: { label: 'Add expense item', iconClassName: 'fa fa-plus mr-10', className: 'dropdown-button-blue', buttonType: 'InsRow', visible: true, order: 6, expose: false },
        ViewDtlListButton: { label: 'View expense items', iconClassName: 'fa fa-eye mr-10', className: 'dropdown-button-blue', buttonType: 'ViewDtlList', visible: true, order: 7, expose: false },
      },
      BottomButtons: {
        SaveButton: { label: 'Save Only', visible: true, buttonType: 'Save', order: 1, expose: true },
        SaveCloseButton: { label: 'Save & Pay Me', buttonType: 'SaveClose', visible: true, order: 2, expose: true },
        ViewDtlListButton: { label: 'View Expense Items', buttonType: 'ViewDtlList', visible: false, order: 3, expose: true },
        DeleteButton: { label: 'Delete Report', buttonType: 'Delete', visible: false, order: 4, expose: true },
        CopyButton: { label: 'Copy Report', buttonType: 'Copy', visible: false, order: 5, expose: true },
      }
    },
    DtlList: {
      DropdownMenuButtons: {
        CopyDtlButton: { label: 'Copy item', visible: false, iconClassName: 'fa fa-clipboard mr-10', className: 'dropdown-button-blue', buttonType: 'CopyDtl', order: 1, expose: false },
        DeleteIDtlButton: { label: 'Delete item', visible: false, iconClassName: 'fa fa-trash mr-10', className: 'dropdown-button-red', buttonType: 'DeleteDtl', order: 2, expose: false },
        InsRowButton: { label: 'Add expense item', buttonType: 'InsRow', visible: false, iconClassName: 'fa fa-plus mr-10', className: 'dropdown-button-blue', order: 3, expose: false },
      },
      RowButtons: {
        DeleteIDtlButton: { label: 'Delete item', visible: false, iconClassName: 'fa fa-trash', exposedClassName: 'edit-icon', className: 'dropdown-button-red', buttonType: 'DeleteDtl', order: 2, expose: false },
        CopyDtlButton: { label: 'Copy item', visible: false, iconClassName: 'fa fa-clipboard', exposedClassName: 'edit-icon', className: 'dropdown-button-blue', buttonType: 'CopyDtl', order: 1, expose: false },
        EditItemButton: { label: 'View item', visible: false, iconClassName: 'fa fa-eye', exposedClassName: 'edit-icon', className: 'dropdown-button-blue', buttonType: 'EditDtl', order: 3, expose: false },
      },
      BottomButtons: {
        InsRowButton: { label: 'Add Expense Item', visible: false, buttonType: 'InsRow', order: 1, expose: true },
        DeleteIDtlButton: { label: 'Delete Item', visible: false, buttonType: 'DeleteDtl', order: 3, expose: true },
        CopyDtlButton: { label: 'Copy Item', visible: false, buttonType: 'CopyDtl', order: 5, expose: true },
      }
    },
    Dtl: {
      DropdownMenuButtons: {
        CopyDtlButton: { label: 'Copy item', visible: true, iconClassName: 'fa fa-clipboard mr-10', className: 'dropdown-button-blue', buttonType: 'CopyDtl', order: 1, expose: false },
        DeleteIDtlButton: { label: 'Delete item', visible: true, iconClassName: 'fa fa-trash mr-10', className: 'dropdown-button-red', buttonType: 'DeleteDtl', order: 2, expose: false },
      },
      BottomButtons: {
        NewSaveDtlButton: { label: 'Save & New Expense Item', buttonType: 'NewSaveDtl', order: 1, visible: false, expose: true },
        SaveButton: { label: 'Save Expense Item', buttonType: 'Save', order: 2, visible: true, expose: true },
        SaveCloseDtlButton: { label: 'Save & Close', buttonType: 'SaveCloseDtl', visible: false, order: 3, expose: true },
        DeleteIDtlButton: { label: 'Delete Item', buttonType: 'DeleteDtl', visible: false, order: 4, expose: true }
      }
    }
  },
  MaxImageSize: {
    Width: 1024,
    Height: 768,
  },
  SearchList: {
    key: Date.now(),
    data: [],
  },
  Mst: {
    BTrxId64: null,
    CompanyId64: null,
    ProjectId64: null,
    MemberId64: null,
    CustomerJobId64: null,
    TrxDate64: null,
    CurrencyId64: null,
    TrxTotal64: null,
    TrxDocId64: null,
    TrxNote64: null,
    Posted64: false,
  },
  NewMst: {
    BTrxId64: null,
    CompanyId64: null,
    ProjectId64: null,
    MemberId64: null,
    CustomerJobId64: null,
    TrxDate64: null,
    CurrencyId64: null,
    TrxTotal64: null,
    TrxDocId64: null,
    TrxNote64: null,
    Posted64: false,
  },
  EditDtl: {
    BTrxDetId65: null,
    TrxDetImg65: null,
    TrxDetDate65: null,
    BGlChartId65: null,
    TrxDetDesc65: null,
    LocalCurrency65: 'N',
    HasReceipt65: 'N',
    TrxDetAmt65: null,
    TrxDetGst65: null,
  },
  NewDtl: {
    BTrxId64: null,
    CompanyId64: null,
    ProjectId64: null,
    MemberId64: null,
    CustomerJobId64: null,
    TrxDate64: null,
    CurrencyId64: null,
    TrxTotal64: null,
    TrxDocId64: null,
    TrxNote64: null,
    Posted64: false,
  },
  DtlList: {
    key: Date.now(),
    list: [],
  },
  ddl: {
    // CompanyId64:
    //   [
    //     {
    //       key: "1",
    //       value: "1",
    //       label: "Company 1"
    //     }
    //   ]
    // ,
    CurrencyId64: [
      {
        key: "1",
        value: "1",
        label: "USD"
      }
    ]
  },
  // ProjectId64: {
  //   list: [
  //     {
  //       key: "1",
  //       value: "1",
  //       label: "Project 1"
  //     }
  //   ]
  // },
  MemberId64: {
    list: [
      {
        key: "1",
        value: "1",
        label: "Member 1"
      }
    ]
  },
  ScreenFilter: [],
  ScreenCriteria: {
    SearchStr: '',
    TopN: 6,
    Increment: 5,
    FilterId: 0,
    MemberId10: {
      ColumnHeader: "Member",
      LastCriteria: ''
    },
    CustomerJobId20: {
      ColumnHeader: "Job",
      LastCriteria: ''
    },
    Posted30: {
      ColumnHeader: "Posted",
      LastCriteria: 'N'
    },
    ShowFilter: true,
    key: Date.now(),
  },
  // CustomerJobId64: {
  //   list: [
  //     {
  //       key: "1",
  //       value: "1",
  //       label: "Job 1"
  //     }
  //   ]
  // },
  DtlFilter: {
    FilterColumnDdl: [],
    FilteredColumn: "_",
    FilteredValue: "",
    PageSize: 5,
    SortColumn: "",
    SortOrder: "A",
    ShowFilter: false,
    Limit: 5,
  },
  page_loading: false,
  saving: false,
  initialized: false,
};

function RefreshMst(mst, refresh) { return refresh ? { ...mst, key: Date.now() } : mst }
function RefreshEditDtl(dtl, refresh) { return refresh ? { ...dtl, key: Date.now() } : dtl }

function ReviseSearchListSelection(SearchList, payload) {
  const m = SearchList
    .filter(v => v.key || v.BTrxId64)
    .map(
      (v, i) => {
        return {
          ...v,
          isSelected:
            (payload.SelectedKeyId && payload.SelectedKeyId === (v.BTrxId64 || v.key))
            ||
            (!payload.SelectedKeyId && payload.SelectedCurrencyId === v.CurrencyId64)
            ||
            (!payload.SelectedKeyId && !payload.SelectedCurrencyId && i === 0 && false)

        }
      }
    )
  return m;
}
export function XrsBTrxReducer(state = initialState, action) {
  const payload = action.payload;
  switch (action.type) {
    case VIEW_MORE_DTL.SUCCEEDED:
      return {
        ...state,
        DtlFilter: {
          ...state.DtlFilter,
          Limit: state.DtlFilter.Limit + state.DtlFilter.PageSize
        },
      };
    case CHANGE_MSTLIST_FILTER_VISIBILITY:
      return {
        ...state,
        ScreenCriteria: {
          ...state.ScreenCriteria,
          ShowFilter: typeof action.show === "undefined" ? !state.ScreenCriteria.ShowFilter : action.show
        }
      }
    case CHANGE_DTLLIST_FILTER_VISIBILITY:
      return {
        ...state,
        DtlFilter: {
          ...state.DtlFilter,
          ShowFilter: typeof action.show === "undefined" ? !state.DtlFilter.ShowFilter : action.show
        }
      }
    case CHANGE_DTLLIST_FILTER:
      return {
        ...state,
        DtlFilter: {
          ...state.DtlFilter,
          FilteredColumn: payload.FilteredColumn || state.DtlFilter.FilteredColumn,
          FilteredValue: payload.FilteredValue,
        }
      }
    case LOAD_PAGE.STARTED:
      return { ...state, page_loading: true };
    case LOAD_PAGE.SUCCEEDED:
      const revisedState = {
        ...state,
        AuthCol: payload.AuthCol,
        AuthRow: payload.AuthRow,
        ColumnLabel: payload.ColumnLabel,
        SearchList: {
          key: Date.now(),
          data: payload.SearchList,
        },
        NewMst: payload.NewMst,
        NewDtl: payload.NewDtl,
        ScreenFilter: payload.ScreenFilter,
        ScreenButtonHlp: payload.ScreenButtonHlp,
        ScreenCriteria: {
          SearchStr: state.ScreenCriteria.SearchStr,
          TopN: state.ScreenCriteria.TopN,
          FilterId: state.ScreenCriteria.FilterId,
          Increment: state.ScreenCriteria.Increment,
          ...payload.ScreenCriteria,
          key: Date.now()
        },
        ScreenCriDdl:
        {
          MemberId10: payload.CriMemberIdList,
          CustomerJobId20: payload.CustomerJobIdList,
          Posted30: payload.CheckBoxCdList
        },
        Label: {
          ...state.Label,
          ...payload.Label,
        },
        ddl:
        {
          ...state.ddl,
          CurrencyId64: payload.CurrencyId64List || state.ddl.CurrencyId64,
          CompanyId64: payload.CompanyId64List || state.ddl.CompanyId64,
          ProjectId64: payload.ProjectId64List || state.ddl.CurrencyId64,
          MemberId64: payload.MemberId64List || state.ddl.ProjectId64,
          CustomerJobId64: payload.CustomerJobId64List || state.ddl.CustomerJobId64,
          BGlChartId65: payload.BGlChartId65List || state.ddl.BGlChartId65,

        },
        DtlFilter: {
          ...state.DtlFilter,
          FilterColumnDdl: [{ ColName: '_', ColumnHeader: 'All' }, ...ExpandDtlFilter(payload.AuthCol, payload.ColumnLabel)],
        },
        page_loading: false,
        initialized: true,
        access_denied: false,
      };
      return (revisedState);
    case LOAD_PAGE.FAILED:
      return {
        ...state
        , page_loading: false
        , access_denied: (action.payload.error || {}).errType === "access denied error"
      };
    case LOAD_PAGE.END:
      return { ...state, page_loading: false };
    case GET_SEARCH_LIST.STARTED:
      return { ...state, page_loading: true };
    case GET_SEARCH_LIST.SUCCEEDED:
      return {
        ...state,
        SearchList: {
          key: Date.now(),
          data: ReviseSearchListSelection(payload.SearchList, payload),
        },
        ScreenCriteria: {
          ...state.ScreenCriteria,
          SearchStr: payload.SearchStr,
          TopN: payload.TopN,
          Total: payload.Total,
          FilterId: payload.FilterId
        },
        page_loading: false
      };
    case GET_SEARCH_LIST.FAILED:
      return {
        ...state,
        page_loading: false
      }

    case SELECT_MST.SUCCEEDED:
      {
        return {
          ...state,
          Mst: {
            ...state.Mst,
            BTrxId64: payload.SelectedKeyId,
            CurrencyId64: payload.SelectedCurrencyId,
          },
          SearchList: {
            key: Date.now(),
            data: ReviseSearchListSelection((state.SearchList || {}).data, payload),
          },
        };

      }
    case GET_MST.STARTED:
      return { ...state, page_loading: true };
    case GET_MST.SUCCEEDED:
      return {
        ...state
        , Mst: ExpandMst(payload.Mst, state, payload.copy)
        , SearchList: {
          key: Date.now(),
          data: ReviseSearchListSelection((state.SearchList || {}).data, { ...payload, SelectedKeyId: payload.Mst.BTrxId64 })
        }
        , EditDtl: {
          ...GetDefaultDtl(state),
          key: Date.now()
        }
        , page_loading: false
      };
    case GET_MST.FAILED:
      return {
        ...state
        , Mst: initialState.Mst
        , DtlList: initialState.DtlList
        , page_loading: false
      };
    case GET_MST.ENDED:
      return { ...state, page_loading: false };
    case GET_DTL_LIST.SUCCEEDED:
      return {
        ...state
        , DtlList: {
          key: Date.now(),
          data: ExpandDtl(payload.Dtl, payload.copy)
        },
      };
    case EDIT_DTL.SUCCEEDED:
      log.debug(payload);
      return {
        ...state
        ,
        EditDtl: {
          ...GetDefaultDtl(state),
          ...payload.dtl,
          ...payload.copy ? { BTrxDetId65: null } : {},
          key: Date.now()
        }
      };

    case SAVE_MST.STARTED:
      return { ...state, page_saving: true };

    case SAVE_MST.END:
      return { ...state, page_saving: false };

    case SAVE_MST.SUCCEEDED:
      return {
        ...state
        , Mst: ExpandMst(payload.Mst, state)
        , EditDtl:
        {
          ...(payload.keepDtl ? state.EditDtl : GetDefaultDtl(state)),
          key: Date.now()
        }
        , page_saving: false
      };

    case SAVE_MST.FAILED:
      return {
        ...state
        , page_saving: false
      };
    case GET_DDL_CHARTID.SUCCEEDED:
      const chartState = {
        ...state,
        ddl:
        {
          ...state.ddl,
          BGlChartId65: payload.BGlChartId65List || state.ddl.BGlChartId65
        },
        EditDtl: RefreshEditDtl(state.EditDtl, payload.backfill),
        page_loading: false,
      };
      return (chartState);
    case GET_DDL_CURRENCYID.SUCCEEDED:
      const currencyState = {
        ...state,
        ddl:
        {
          ...state.ddl,
          CurrencyId64: payload.CurrencyId64List || state.ddl.CurrencyId64
        },
        page_loading: false,
      };
      return (currencyState);
    case GET_DDL_MEMBERID.SUCCEEDED:
      const memberState = {
        ...state,
        ddl:
        {
          ...state.ddl,
          MemberId64: payload.MemberId64List || state.ddl.MemberId64
        },
        page_loading: false,
      };
      return (memberState);
    case GET_DDL_PROJECTID.SUCCEEDED:
      const projectState = {
        ...state,
        ddl:
        {
          ...state.ddl,
          ProjectId64: payload.ProjectId64List || state.ddl.ProjectId64
        },
        page_loading: false,
      };
      return (projectState);
    case GET_DDL_CUSTOMERJOBID.SUCCEEDED:
      const customerJobState = {
        ...state,
        ddl:
        {
          ...state.ddl,
          CustomerJobId64: payload.CustomerJobId64List || state.ddl.CustomerJobId64
        },
        Mst: RefreshMst(state.Mst, payload.backfill),
        page_loading: false,
      };
      return (customerJobState);
    case SAVE_CRI.STARTED:
      return {
        ...state
        , page_saving: true
      };
    case SAVE_CRI.SUCCEEDED:
      return {
        ...state,
        Mst: {
          ...state.Mst,
          key: Date.now()
        },
        ScreenCriteria: {
          ...state.ScreenCriteria,
          MemberId10: {
            ...state.ScreenCriteria.MemberId10,
            LastCriteria: payload.Cri.MemberId10
          },
          CustomerJobId20: {
            ...state.ScreenCriteria.CustomerJobId20,
            LastCriteria: payload.Cri.CustomerJobId20
          },
          Posted30: {
            ...state.ScreenCriteria.Posted30,
            LastCriteria: payload.Cri.Posted30
          },
          key: Date.now()
        },
        page_saving: false
      };
    case SAVE_CRI.FAILED:
      return { ...state, page_saving: false };
    default:
      return state;
  }
}

//selector
export function SearchListToSelectList(state) {
  const searchList = ((state || {}).SearchList || {}).data || [];
  return searchList
    .map((v, i) => {
      return {
        key: v.BTrxId64 || v.key || null,
        label: v.CurrencyId64Text || "",
        memo: v.TrxNote64 || v.label || "",
        value: v.TrxTotal64 || "0.0",
        idx: i,
        CurrencyId64: v.CurrencyId64,
        isSelected: v.isSelected,
      }
    })
}

export function DtlListToSelectList(state) {
  const isDdlType = {
    "ComboBox": true, "DropDownList": true, "ListBox": true, "RadioButtonList": true
  };
  const DtlFilter = state.DtlFilter;
  const DtlList = (state.DtlList || {}).data || [];
  const FilteredColumn = DtlFilter.FilteredColumn;

  if (!Array.isArray(state.AuthCol)) return DtlList;

  const columnsToCheck = state.AuthCol
    .filter((v) => v.MasterTable === "N" && v.ColVisible !== "N" && !v.DisplayName.match(/Button/g) && (FilteredColumn === "_" || v.ColName === FilteredColumn))
    .reduce((a, v) => { a[v.ColName + (isDdlType[v.DisplayName] ? "Text" : "")] = true; return a; }, {});
  const EditDtl = state.EditDtl || {};
  const FilterColumn = DtlFilter.FilterColumnDdl;
  const FilteredValue = DtlFilter.FilteredValue;
  const noFilter = FilteredValue === "" || FilteredValue === undefined || FilteredValue === null;
  const searchRegEx = new RegExp(FilteredValue, 'i');

  return DtlList
    .filter(v => {
      return noFilter
        // || (FilteredColumn !== "_" && (v[columnsToCheck[FilteredColumn]] || "").match(searchRegEx)) 
        || (Object.keys(v).filter(n => columnsToCheck[n] && (v[n] || "").match(searchRegEx)).length > 0)
    }
    )
    .map((v, i) => {
      return {
        ...v,
        idx: i,
        isSelected: (EditDtl || {}).BTrxDetId65 && ((EditDtl || {}).BTrxDetId65 === (v || {}).BTrxDetId65),
      }
    })
}

//selector for GlChartId65 (account list)
export function BGlChartId65ToSelectList(BGlChartId65) {
  return BGlChartId65.map((v, i) => {
    return {
      key: v.key || null,
      label: v.label || "",
      value: v.key || "",
      idx: i
    }
  })
}

export function ShowSpinner(state) {
  return !state || state.page_loading || state.page_saving;
}

//criteria
//selector for MemberId10 
export function MemberId10DdlToSelectList(state) {
  return ((((state || {}).ScreenCriDdl || {}).MemberId10) || []).map((v, i) => {
    return {
      key: v.key || null,
      label: v.label || "",
      value: v.key || "",
      idx: i
    }
  })
}
//selector for CustomerJobId20 
export function CustomerJobId20DdlToSelectList(state) {
  return ((((state || {}).ScreenCriDdl || {}).CustomerJobId20) || []).map((v, i) => {
    return {
      key: v.key || null,
      label: v.label || "",
      value: v.key || "",
      idx: i
    }
  })
}
//selector for Posted30 
export function Posted30DdlToSelectList(state) {
  return ((((state || {}).ScreenCriDdl || {}).Posted30) || []).map((v, i) => {
    return {
      key: v.CheckBoxCd,
      label: v.CheckBoxName || " ",
      value: v.CheckBoxCd,
      idx: i
    }
  })
}

export function FilterDdlToSelectList(state) {
  return ((state || {}).ScreenFilter || {}).map((v, i) => {
    return {
      key: v.ScreenFilterId,
      label: v.FilterName || " ",
      value: v.ScreenFilterId,
      idx: i
    }
  })
}

//selector for CurrencyId64
export function CurrencyId64DdlToSelectList(state) {
  return ((((state || {}).ddl || {}).CurrencyId64) || []).map((v, i) => {
    return {
      key: v.CurrencyId64 || "",
      label: v.CurrencyId64Text || " ",
      value: v.CurrencyId64 || "",
      idx: i
    }
  })
}

//selector for CustomerJobId64 
export function CustomerJobId64DdlToSelectList(state) {
  return ((((state || {}).ddl || {}).CustomerJobId64) || []).map((v, i) => {
    return {
      key: v.CustomerJobId64 || null,
      label: v.CustomerJobId64Text || "",
      value: v.CustomerJobId64 || "",
      idx: i
    }
  })
}

//selector for CompanyId64
export function CompanyId64DdlToSelectList(state) {
  log.debug("companyId" , state);
  return ((((state || {}).ddl || {}).CompanyId64) || []).map((v, i) => {
    return {
      key: v.CompanyId64 || "",
      label: v.CompanyId64Text || " ",
      value: v.CompanyId64 || "",
      idx: i
    }
  })
}

//selector for ProjectId64
export function ProjectId64DdlToSelectList(state) {
  return ((((state || {}).ddl || {}).ProjectId64) || []).map((v, i) => {
    return {
      key: v.ProjectId64 || "",
      label: v.ProjectId64Text || " ",
      value: v.ProjectId64 || "",
      idx: i
    }
  })
}

export function ExpandDtlFilter(authCol, columnLabel) {
  const cols = authCol
    .filter((v) => v.MasterTable === "N" && v.ColVisible !== "N" && !v.DisplayName.match(/Button/g))
    .map((v) => ({ ColName: v.ColName, ColumnHeader: (columnLabel[v.ColName] || {}).ColumnHeader || v.ColName }));
  return cols;
}
export function ExpandMst(mst, state, copy) {
  return {
    ...mst,
    CurrencyId64Text: GetCurrencyId64Cd(mst.CurrencyId64, state),
    MemberId64Text: GetMemberId64Text(mst.MemberId64, state),
    key: Date.now(),
    BTrxId64: copy ? null : mst.BTrxId64
  }
}
export function ExpandDtl(dtlList, copy) {
  if (!copy) return dtlList;
  else return dtlList.map(v => {
    return {
      ...v,
      BTrxId64: null,
      BTrxDetId65: null,
    }
  });
}
export function GetMemberId64Text(MemberId64, state) {
  try {
    const d = (state.ddl.MemberId64).reduce((r, v, i, a) => { r[v.key] = v.label; return r; }, {});
    return (d || {})[MemberId64];
  } catch (e) {
    return "";
  }
}

export function GetCurrencyId64Text(CurrencyId64, state) {
  try {
    const d = (state.ddl.CurrencyId64).reduce((r, v, i, a) => { r[v.CurrencyId64] = v.CurrencyId64Text; return r; }, {});
    return (d || {})[CurrencyId64];
  } catch (e) {
    return "";
  }
}

export function GetCurrencyId64Cd(CurrencyId64, state) {
  try {
    const d = ((state.SearchList || {}).data || []).reduce((r, v, i, a) => { r[v.CurrencyId64] = v.CurrencyId64Text; return r; }, {});
    return (d || {})[CurrencyId64];
  } catch (e) {
    return "";
  }
}


export function GetDefaultMst(searchList, state) {
  const mst = searchList.reduce((r, v, i, a) => {
    return (v.isSelected || (i === 0) ? v : r);
  }, {});
  return mst;
}

export function GetDefaultDtl(state) {
  return (state || {}).NewDtl || {
    BTrxDetId65: null,
    TrxDetImg65: null,
    TrxDetDate65: null,
    BGlChartId65: null,
    TrxDetDesc65: null,
    LocalCurrency65: 'N',
    HasReceipt65: 'N',
    TrxDetAmt65: null,
    TrxDetGst65: null,
  }
}

export function GetDtl(dtlList, dtlId, idx) {
  const rememberedDtl = GetCurrent("XrxBTrx_Dtl");
  log.debug("getdtl", rememberedDtl, dtlList);
  return dtlList.reduce((a, v, i) =>
    (
      (dtlId && v.BTrxDetId65 === dtlId)
      ||
      (dtlId === "_"
        && idx < 0
        &&
        (
          (rememberedDtl || {}).BTrxDetId65 === v.BTrxDetId65 || (v.TmpKeyId && (rememberedDtl || {}).TmpKeyId === v.TmpKeyId)
        )
      )
      ||
      ((!dtlId || dtlId === "_") && i === idx)
    ) ? v : a, null);
}

export function GetMst(mstList, mstId, idx) {
  const rememberedMst = GetCurrent("XrxBTrx_Mst");
  log.debug("getmst", rememberedMst, mstList);
  return mstList.reduce((a, v, i) =>
    (
      (mstId && v.key === mstId)
      ||
      (mstId === "_"
        && idx < 0
        &&
        (
          (rememberedMst || {}).BTrxId64 === v.key || (v.TmpKeyId && (rememberedMst || {}).TmpKeyId === v.TmpKeyId)
        )
      )
      ||
      ((!mstId || mstId === "_") && i === idx)
    ) ? v : a, null);
}

export function GetBottomAction(state) {
  // return ['InsRow', 'ViewGrid'];
  return (state || {}).BottomButtons || {};
}
export function GetRowAction(state) {
  // return ['InsRow', 'ViewGrid'];
  return (state || {}).RowButtons || {};
}
export function GetDropdownAction(state) {
  // return ['SaveClose', 'Save','New', 'ExpTxt', 'Copy', 'UndoAll', 'Delete'];
  return (state || {}).DropdownMenuButtons || {};
}
// export function GetMstQuickAction()
// {
//   return ['Save','SaveClose'];
// }
// export function GetDtlListQuickAction()
// {
//   return ['InsRow'];
// }
// export function GetDtlListAction()
// {
//   return ['InsRow'];
// }
// export function GetDtlListContextAction()
// {
//   return ['DelRow'];
// }
// export function GetDtlAction()
// {
//   return ['CopyRow','DelRow','AcceptRow','SaveRow'];
// }

export function GetActionButtonLabel(buttonTypeName, buttonName, screenButtonHlp, labels) {
  return {
    label: labels[buttonTypeName + 'Btn'] || (screenButtonHlp[buttonTypeName].ButtonName) || buttonName,
    tooltip: labels[buttonTypeName + 'BtnHlp'] || (screenButtonHlp[buttonTypeName].ButtonToolTip) || "",
    icon: null,
  }
}
//actions for redux(use the redux-thunk construct if there is complicated logic especially async)
export function ChangeMstListFilterVisibility(show) {
  return {
    type: CHANGE_MSTLIST_FILTER_VISIBILITY, payload: { show: show || true }
  };
}

export function ViewMoreDtl() {
  return {
    type: VIEW_MORE_DTL.SUCCEEDED, payload: {}
  };
}

export function ChangeDtlListFilterVisibility(show) {
  return {
    type: CHANGE_DTLLIST_FILTER_VISIBILITY, payload: { show: show || true }
  };
}
export function ChangeDtlListFilter(FilteredColumn, FilteredValue) {
  return {
    type: CHANGE_DTLLIST_FILTER, payload: { FilteredColumn, FilteredValue }
  };
}
export function SearchBGlChartId65(v, currencyId) {
  return (dispatch, getState, { webApi }) => {
    const apiService = webApi.XrsBTrxService || XrsBTrxService;
    const current = getState().XrsBTrx || {};
    const keyLookup = (v || '').startsWith("**")
      ? apiService.GetBGlChartId65List(v, 50, currencyId)
      : new Promise((resolve) => resolve({ data: { data: [] } }));
    const promises = [
      keyLookup,
      apiService.GetBGlChartId65List((v || '').startsWith("**") ? null : v, 50, currencyId),
    ];
    return Promise.all(promises)
      .then(([keyLookup, ret]) => {
        dispatchWithNotification(dispatch, {
          type: GET_DDL_CHARTID.SUCCEEDED, payload: {
            BGlChartId65List: mergeArray(keyLookup.data.data, ret.data.data, (o) => o.key),
            backfill: (v || '').startsWith("**"),
          }
        });
      }
        , (err) => {
          log.trace(err);
        })
      .catch(err => {
        log.trace(err);
      })
  }
}

export function SearchCurrencyId64(v, currencyId) {
  return (dispatch, getState, { webApi }) => {
    const apiService = webApi.XrsBTrxService || XrsBTrxService;
    const current = getState().XrsBTrx || {};
    apiService.GetCurrencyId64List(v, 50, currencyId)
      .then(ret => {
        dispatch({
          type: GET_DDL_CURRENCYID.SUCCEEDED, payload: {
            CurrencyId64List: ret.data.data
          }
        });
      }
        , (err) => {
          log.trace(err);
        })
      .catch(err => { log.trace(err); })
  }
}

export function SearchCustomerJobId64(v) {
  return (dispatch, getState, { webApi }) => {
    const apiService = webApi.XrsBTrxService || XrsBTrxService;
    const current = getState().XrsBTrx || {};
    const keyLookup = (v || '').startsWith("**")
      ? apiService.GetCustomerJobId64List(v, 50, null)
      : new Promise((resolve) => resolve({ data: { data: [] } }));
    const promises = [
      keyLookup,
      apiService.GetCustomerJobId64List((v || '').startsWith("**") ? null : v, 50, null),
    ];
    return Promise.all(promises)
      .then(([keyLookup, ret]) => {
        dispatch({
          type: GET_DDL_CUSTOMERJOBID.SUCCEEDED, payload: {
            CustomerJobId64List: mergeArray(keyLookup.data.data, ret.data.data, (o) => o.key),
            backfill: (v || '').startsWith("**"),
          }
        });
      }
        , (err) => {
          log.trace(err);
        })
      .catch(err => { log.trace(err); })
  }
}

export function SearchMemberId64(v) {
  return (dispatch, getState, { webApi }) => {
    const apiService = webApi.XrsBTrxService || XrsBTrxService;
    const current = getState().XrsBTrx || {};
    apiService.GetMember64IdList(v, 50, null)
      .then(ret => {
        dispatch({
          type: GET_DDL_MEMBERID.SUCCEEDED, payload: {
            MemberId64List: ret.data.data
          }
        });
      }
        , (err) => {
          log.trace(err);
        })
      .catch(err => { log.trace(err); })
  }
}

export function SelectMst(keyId, altKeyId, idx) {
  log.debug("select mst", keyId, altKeyId, idx);
  return (dispatch, getState, { webApi }) => {
    const apiService = webApi.XrsBTrxService || XrsBTrxService;
    const current = getState().XrsBTrx || {};
    const currentList = (current.SearchList || {}).data || [];
    const currentMstId = currentList.length > 0 ? currentList[idx].keyId || currentList[idx].key : null;
    if (currentList.length > 0) {
      dispatchWithNotification(dispatch, { type: SELECT_MST.SUCCEEDED, payload: { SelectedKeyId: currentMstId } });
      LoadMst(currentMstId, "MstList")(dispatch, getState, { webApi });
    }
    else {
      dispatchWithNotification(dispatch, { type: SELECT_MST.FAILED, payload: { error: "empty selection list" } })
    }
  }
}

export function SelectDtl(mstId, dtlId, idx) {
  return (dispatch, getState, { webApi }) => {
    const apiService = webApi.XrsBTrxService || XrsBTrxService;
    const current = getState().XrsBTrx || {};
    const currentMstList = (current.SearchList || {}).data;
    const mst = current.Mst;
    const currentDtlList = (current.DtlList || {}).data;
    log.debug("select detail", mstId, dtlId, idx)
    if (mst.BTrxId64 === mstId || mstId === "_") {
      const rememberedDtl = GetCurrent("XrxBTrx_Dtl");
      if (currentDtlList.length > 0) {
        const dtl = GetDtl(currentDtlList, dtlId, idx);
        log.debug(dtl);
        if (dtl) RememberCurrent("XrxBTrx_Dtl", dtl);
        log.debug(GetCurrent("XrxBTrx_Dtl"));
        SearchBGlChartId65('**' + ((dtl || {}).BGlChartId65 || "0"), (mst || {}).CurrencyId64)(dispatch, getState, { webApi });

        dispatch({ type: EDIT_DTL.SUCCEEDED, payload: { dtl: dtl || (dtlId === '_' ? rememberedDtl : {}) } });
      }
      else {
        dispatch({ type: EDIT_DTL.SUCCEEDED, payload: { dtl: {} } });
      }
    }
    else {
      LoadMst(mstId, { dtlId: dtlId })(dispatch, getState, { webApi });
    }
  }
}

export function AddDtl(mstId, dtlId, idx) {
  return (dispatch, getState, { webApi }) => {
    const apiService = webApi.XrsBTrxService || XrsBTrxService;
    const current = getState().XrsBTrx || {};
    const currentMstList = (current.SearchList || {}).data;
    const mst = current.Mst;
    const currentDtlList = (current.DtlList || {}).data;
    const dtl = GetDtl(currentDtlList, dtlId, idx);
    const newDtl = { ...(dtl || current.newDtl), BTrxDetId65: null };
    log.debug("add/copy detail", mstId, dtlId, idx, newDtl);
    RememberCurrent("XrxBTrx_Dtl", newDtl);
    log.debug("add/copy detail", mstId, dtlId, idx)
    dispatchWithNotification(dispatch, { type: EDIT_DTL.SUCCEEDED, payload: { dtl: newDtl || {}, message: dtlId ? "New copy of the detail" : "" } });
  }
}

export function AddMst(mstId, src, idx) {
  return (dispatch, getState, { webApi }) => {
    log.debug("add mst", mstId);
    LoadMst(mstId, src, { copy: mstId && true })(dispatch, getState, { webApi });
  }
}

export function LoadMst(mstId, src, options = {}) {
  return (dispatch, getState, { webApi }) => {
    const apiService = webApi.XrsBTrxService || XrsBTrxService;
    const current = getState().XrsBTrx || {};
    const rememberedMst = GetCurrent("XrxBTrx_Mst");
    const rememberedDtl = GetCurrent("XrxBTrx_Dtl");
    const selectedMst = GetDefaultMst((current.SearchList || {}).data, current);
    const newMst = current.NewMst || {};
    const newDtl = current.NewDtl || {};
    const currMst = current.Mst;
    //const keyId = src === 'Mst' && !mstId ? null : (selectedMst || {}).BTrxId64 || (selectedMst || {}).key;
    const keyId = mstId !== '_' ? (mstId || ({}).key) : mstId && (rememberedMst || {}).BTrxId64;
    const { dtlId, copy } = options;
    const currentDtlList = (current.DtlList || {}).data;
    log.debug("load mst", src, options, mstId, selectedMst, keyId, currMst);
    log.debug(currentDtlList);

    if (keyId
      //&& src !== "Dtl" && src !== "DtlList" 
      &&
      ((currMst.BTrxId64 !== keyId) || true )
    ) {
      log.debug("reload mst", keyId);
      Promise.all([
        apiService.GetXrsBTrx48ById(keyId),
        apiService.GetXrsBTrx48DtlById(keyId),
      ])
        .then(([mst, dtl]) => {
          log.debug(mst, dtl);
          const revisedMst = {
            ...mst.data[0],
            BTrxId64: copy ? null : mst.data[0].BTrxId64
          };
          log.debug("revise master", revisedMst);
          RememberCurrent("XrxBTrx_Mst", revisedMst);
          dispatchWithNotification(dispatch, { type: GET_MST.SUCCEEDED, payload: { Mst: revisedMst, message: copy ? "This is a new copy of the master" : "", copy, Src: src } })
          dispatchWithNotification(dispatch, { type: GET_DTL_LIST.SUCCEEDED, payload: { Dtl: dtl.data, copy, Src: src } })
          SearchCurrencyId64(null)(dispatch, getState, { webApi });
          if (dtlId) {
            SelectDtl(mstId, dtlId, -1)(dispatch, getState, { webApi });
          }
          SearchCustomerJobId64(null)(dispatch, getState, { webApi });
        },
          (err) => {
            dispatchWithNotification(dispatch, { type: GET_MST.FAILED, payload: {} })
            dispatchWithNotification(dispatch, { type: GET_DTL_LIST.FAILED, payload: {} })
          }
        )
        .catch(error => {
          dispatchWithNotification(dispatch, { type: GET_MST.FAILED, payload: {} })
          dispatchWithNotification(dispatch, { type: GET_DTL_LIST.FAILED, payload: {} })
        })
    }
    else {
      log.debug("skip reload mst", mstId, dtlId);
      const useCopy = rememberedMst && !rememberedMst.BTrxId64 && (keyId || mstId);
      log.debug("skip reload mst", mstId, dtlId, rememberedMst, useCopy);
      SearchCurrencyId64(null)(dispatch, getState, { webApi });
      SearchCustomerJobId64(null, selectedMst.CustomerJobId64)(dispatch, getState, { webApi });
      dispatchWithNotification(dispatch, { type: GET_MST.SUCCEEDED, payload: { Mst: keyId ? currMst : useCopy ? rememberedMst : newMst, Src: src } })
      dispatchWithNotification(dispatch, { type: GET_DTL_LIST.SUCCEEDED, payload: { Dtl: keyId ? currentDtlList : useCopy ? currentDtlList : [], Src: src } })
      if (dtlId) {
        const dtl = GetDtl(currentDtlList, dtlId, -1);
        dispatchWithNotification(dispatch, { type: EDIT_DTL.SUCCEEDED, payload: { dtl: dtl || (dtlId === '_' ? rememberedDtl : {}) } });
      }
    }

  }
}

export function LoadPageStaticData(dispatch, apiService, user, current) {
  const isInitialized = current.initialized;
  const scope = (({ CompanyId, ProjectId, SystemId, CultureId }) => ({ CompanyId, ProjectId, SystemId, CultureId }))(user || {});
  if (isInitialized) {
    return new Promise(function (resolve, reject) {
      resolve({
        AuthCol: current.AuthCol,
        AuthRow: current.AuthRow,
        Label: current.Label,
        NewMst: current.NewMst,
        NewDtl: current.NewDtl,
        CompanyId64List: current.CompanyId64List,
        ProjectId64List: current.ProjectId64List,
        MemberId64List: current.MemberId64List,
        CustomerJobId64List: current.CustomerJobId64List,
        CurrencyId64List: current.CurrencyId64List,
        BGlChartId65List: current.BGlChartId65ToSelectList,
      })
    })
  }
  else {
    // below should only happens once
    dispatchWithNotification(dispatch, { type: LOAD_PAGE.STARTED, payload: {} });
    const promises = [
      apiService.GetAuthCol(scope),
      apiService.GetAuthRow(scope),
      apiService.GetScreenLabel(scope),
      apiService.GetScreenHlp(scope),
      apiService.GetScreenFilter(),
      apiService.GetScreenCriteria(),
      apiService.GetScreenButtonHlp(),
      apiService.GetLabels('XrsBTrx'),
      apiService.GetNewMst(),
      apiService.GetNewDtl(),
      apiService.GetCompanyId64List(),
      apiService.GetProjectId64List("", 0, "", scope),
      apiService.GetMember64IdList(),
      apiService.GetCustomerJobId64List(),
      apiService.GetCurrencyId64List(),
      apiService.GetBGlChartId65List(null, 1),
      apiService.GetScreenCriMemberIdDdlList("", 0, "", scope),
      apiService.GetScreenCriCustomerJobIdDdlList("", 0, "", scope),
      apiService.GetScreenCriCheckBoxCdDdlList("", 0, "", scope),
    ]
    return Promise.all(promises)
      .then(
        ([AuthCol, AuthRow, ColumnLabel, ScreenHlp, ScreenFilter, ScreenCriteria, ScreenButtonHlp, Labels, NewMst, NewDtl, CompanyId64List, ProjectId64List, MemberId64List, CustomerJobId64List, CurrencyId64List, BGlChartId65List
          , CriMemberIdList, CustomerJobIdList, CheckBoxCdList
        ]) => {
          const payload = {
            AuthCol: AuthCol.data.data,
            AuthRow: AuthRow.data.data,
            ColumnLabel: ColumnLabel.data.data,
            ScreenHlp: ScreenHlp.data,
            ScreenFilter: ScreenFilter.data.data,
            ScreenCriteria: ScreenCriteria.data.data,
            ScreenButtonHlp: ScreenButtonHlp.data.data,
            Label: objectListToDict(Labels.data.data, "LabelKey", (v) => (v.LabelText)),
            NewMst: NewMst.data[0],
            NewDtl: NewDtl.data[0],
            CompanyId64List: CompanyId64List.data.data,
            ProjectId64List: ProjectId64List.data.data,
            MemberId64List: MemberId64List.data.data,
            CustomerJobId64List: CustomerJobId64List.data.data,
            CurrencyId64List: CurrencyId64List.data.data,
            BGlChartId65List: BGlChartId65List.data.data,
            CriMemberIdList: CriMemberIdList.data.data,
            CustomerJobIdList: CustomerJobIdList.data.data,
            CheckBoxCdList: CheckBoxCdList.data.data,
          }
          dispatchWithNotification(dispatch, {
            type: LOAD_PAGE.SUCCEEDED,
            payload: payload
          });
          return payload;
        }
        ,
        (error) => {
          log.debug(error);
          dispatchWithNotification(dispatch, { type: LOAD_PAGE.FAILED, payload: { error: error } })
        }
      )
      .catch(error => {
        log.debug(error);
      });
  }
}

export function LoadSearchList(src, mstId, options, searchStr, topN, filterId) {
  return (dispatch, getState, { webApi }) => {
    const apiService = webApi.XrsBTrxService || XrsBTrxService;
    const rememberedMst = GetCurrent("XrxBTrx_Mst");
    const rememberedMstId = (mstId === "_") && (rememberedMst || {}).BTrxId64;
    const current = getState().XrsBTrx || {};
    const { dtlId, reloadMst, reloadMstList, reloadDtl } = options;
    const specificKeyId = typeof mstId !== 'undefined' && mstId !== '_';
    const currKeyId = specificKeyId ? mstId
      : (typeof mstId !== 'undefined'
        ? (current.Mst || {}).BTrxId64 || rememberedMstId
        : undefined);
    const currCurrencyId = (current.Mst || {}).CurrencyId64;
    log.debug("load search list", src, mstId, options, specificKeyId, currKeyId, rememberedMstId, rememberedMst);
    dispatchWithNotification(dispatch, { type: GET_SEARCH_LIST.STARTED, payload: {} });

    apiService.GetXrsBTrx48List(searchStr, topN, filterId)
      //apiService.WrGetXrsBTrx48Dashboard()
      .then(
        (SearchList => {
          return dispatchWithNotification(dispatch, {
            type: GET_SEARCH_LIST.SUCCEEDED,
            payload: {
              SearchStr: searchStr,
              TopN: topN,
              Total: SearchList.data.total,
              FilterId: filterId,
              SearchList: SearchList.data.data,
              SelectedKeyId: currKeyId,
              SelectedCurrencyId: currCurrencyId
            }
          }).then(
            () => {
              LoadMst(currKeyId || mstId, src, options)(dispatch, getState, { webApi });
            }
          )
        })
        , (error => {
          log.debug(error);
          dispatchWithNotification(dispatch, { type: GET_SEARCH_LIST.FAILED, payload: { error: error } })
        })
      )
  }
}

export function LoadPage(src, options) {
  return (dispatch, getState, { webApi }) => {
    const apiService = webApi.XrsBTrxService || XrsBTrxService;
    const current = getState().XrsBTrx || {};
    const user = (getState().auth || {}).user; // use with cautions, if possible should be passed in from callers if the coupling is tight
    const { mstId, dtlId, reloadMst, reloadMstList, reloadDtl } = options;
    const searchStr = current.ScreenCriteria.SearchStr;
    const topN = current.ScreenCriteria.TopN;
    const filterId = current.ScreenCriteria.FilterId;
    const isInitialized = current.initialized;
    const specificMstId = typeof mstId !== 'undefined' && mstId !== '_';
    log.debug(mstId, dtlId, reloadMst, reloadMstList, reloadDtl)
    return LoadPageStaticData(dispatch, apiService, user, current)
      .then(
        (payload) => {
          LoadSearchList(src, mstId, options, searchStr, topN, filterId)(dispatch, getState, { webApi });
        }
        ,
        (error) => {
          log.debug(error);
        });
  }
}

export function LoadInitPage(options) {
  return (dispatch, getState, { webApi }) => {
    const apiService = webApi.XrsBTrxService || XrsBTrxService;
    const current = getState().XrsBTrx || {};
    const user = (getState().auth || {}).user; // use with cautions, if possible should be passed in from callers if the coupling is tight
    apiService.LoadInitPage(options)
      .then(ret => {
        log.debug(ret);
      },
        (err => {
          log.debug(err);
        })
      )
  }
}
export function SavePage(currentState, mst, dtl, { persist, keepDtl, ...rest }) {
  return (dispatch, getState, { webApi }) => {
    const apiService = webApi.XrsBTrxService || XrsBTrxService;

    dispatchWithNotification(dispatch, { type: SAVE_MST.STARTED, payload: {} });
    const _mst = {
      ...currentState.Mst,
      ...mst
    }
    const _dtl = [
      ...dtl
    ];

    log.debug('DTL', dtl);

    const _options = {
      ...rest
    }

    apiService.SaveData(_mst, _dtl, { ...rest })
      .then(
        (ret => {
          dispatchWithNotification(dispatch, { type: SAVE_MST.SUCCEEDED, payload: { Mst: ret.data.mst, keepDtl: keepDtl, message: ret.data.message } });
          if (!keepDtl) RememberCurrent("XrxBTrx_Dtl", null);
          LoadSearchList("SaveData", ret.data.mst.BTrxId64, { dtlId: keepDtl && (currentState.EditDtl || {}).BTrxDetId65 })(dispatch, getState, { webApi });
        })
        ,
        (err => {
          log.debug(err);

          dispatchWithNotification(dispatch, { type: SAVE_MST.FAILED, payload: { error: err, message: err.errMsg, validationErrors: err.validationErrors } })
        })
      )
    // .finally(x => {
    //   dispatchWithNotification(dispatch, { type: SAVE_MST.ENDED, payload: {} });
    // })
  };
}

export function DelMst(currentState, mstId, { ...rest }) {
  return (dispatch, getState, { webApi }) => {
    const apiService = webApi.XrsBTrxService || XrsBTrxService;
    dispatchWithNotification(dispatch, { type: DEL_MST.STARTED, payload: {} });
    const _mst = {
      BTrxId64: mstId,
    }
    const _options = {
      ...rest
    }

    apiService.DelMst(_mst, { ...rest })
      .then(
        (ret => {
          dispatchWithNotification(dispatch, { type: DEL_MST.SUCCEEDED, payload: { message: ret.data.message } })
          LoadPage("MstList", {})(dispatch, getState, { webApi });
        })
        ,
        (err => {
          log.debug(err);

          dispatchWithNotification(dispatch, { type: DEL_MST.FAILED, payload: { error: err, message: err.errMsg } })
        })
      )
    // .finally(x => {
    //   dispatchWithNotification(dispatch, { type: SAVE_MST.ENDED, payload: {} });
    // })
  };
}

export function ShowMstFilterApplied(state) {
  return !state
    || state.ScreenCriteria.MemberId10.LastCriteria
    || state.ScreenCriteria.CustomerJobId20.LastCriteria
    || state.ScreenCriteria.Posted30.LastCriteria
    || state.ScreenCriteria.SearchStr;
}

export function ShowMoreMstBtn(state) {
  return state && (state.ScreenCriteria.TopN <= state.ScreenCriteria.Total)
}

export function SetScreenCriteria(searchStr, criteria, filterId) {
  return (dispatch, getState, { webApi }) => {
    const apiService = webApi.XrsBTrxService || XrsBTrxService;
    const current = getState().XrsBTrx || {};
    const topN = current.ScreenCriteria.TopN;
    //const filterId = current.ScreenCriteria.FilterId;
    log.debug(criteria);
    dispatchWithNotification(dispatch, { type: SAVE_CRI.STARTED, payload: {} });

    apiService.SetScreenCriteria(criteria)
      .then(
        (ret => {
          dispatchWithNotification(dispatch, { type: SAVE_CRI.SUCCEEDED, payload: { Cri: ret.data, message: ret.data.message } })
            .then((ret) => {
              LoadSearchList(null, null, {}, searchStr, topN, filterId)(dispatch, getState, { webApi });
            },
              (err) => {

              });
        })
        ,
        (err => {
          dispatchWithNotification(dispatch, { type: SAVE_CRI.FAILED, payload: { error: err, message: err.errMsg } })
        })
      )
    // .finally(x => {
    //   dispatchWithNotification(dispatch, { type: SAVE_MST.ENDED, payload: {} });
    // })
  };
}



// WEBPACK FOOTER //
// ./src/redux/XrsBTrx.js